import { FormInputRow, Input } from '@emerald-works-nova/components'
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'
import TinyEditorComponent from '../../../components/tiny-editor'
import { ColourSchemeOptions } from '../../../reducers/campaign-edit/slice'
import { useCampaignFormContext } from '../campaign-form-context'
import { useStyles } from './style'

const Content = () => {
  const classes = useStyles()
  const { form, setCurrentTabValidation } = useCampaignFormContext()
  const { trigger, formState: { errors } } = form

  React.useEffect(() => {
    setCurrentTabValidation(() => () => trigger(['title', 'body', 'ctaText', 'colourScheme']))
  }, [setCurrentTabValidation, trigger])

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12}>
        <FormInputRow
          title='Title'
          description='This title will be applied on all banner pieces of this campaign.'
          autofocus
          smallFormTitles
          InputComponent={<Input label='Banner Title' name='title' control={form.control} />}
        />
      </Grid>
      <Grid item xs={12}>
        <FormInputRow
          title='Body'
          description='This information will be applied on all banner pieces of this campaign.'
          autofocus
          smallFormTitles
          InputComponent={
            <Controller
              name='body'
              control={form.control}
              render={({ field }) => (
                <FormControl
                  variant='outlined'
                  className={classes.bodyCtn}
                  error={errors.body !== undefined}
                >
                  <TinyEditorComponent
                    {...form}
                    name={field.name}
                    value={field.value}
                  />
                </FormControl>
              )}
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <FormInputRow
          title='CTA Text'
          description='This CTA text will be applied on all banner pieces of this campaign.'
          autofocus
          smallFormTitles
          InputComponent={<Input label='Button Text' name='ctaText' control={form.control} />}
        />
      </Grid>
      <Grid item xs={12}>
        <FormInputRow
          title='Colour Scheme'
          description='Choose a predefined colour scheme.'
          autofocus
          smallFormTitles
          InputComponent={
            <Controller
              name='colourScheme'
              control={form.control}
              rules={{ required: true }}
              render={({ field }) =>
                <FormControl error={errors.colourScheme !== undefined} variant='outlined' className={classes.selectControl}>
                  <InputLabel id='colourScheme-select-lbl'>Colour Scheme</InputLabel>
                  <Select
                    variant='outlined'
                    {...field}
                    id='colourScheme-select'
                    labelId='colourScheme-select-lbl'
                    value={field.value || ''}
                  >
                    <MenuItem value=''><em>None</em></MenuItem>
                    {ColourSchemeOptions.map(opt => <MenuItem value={opt.value} key={opt.value}>{opt.label}</MenuItem>)}
                  </Select>
                  {errors.colourScheme !== undefined && (
                    <FormHelperText>Colour Scheme is required</FormHelperText>
                  )}
                </FormControl>}
            />
          }
        />
      </Grid>
    </Grid>
  )
}

export default Content
